import { NULLISH_DATE } from './chunk-3YIOW4BW.mjs';

// src/helpers/register/ticket/ticketElementSent.ts
var isNullishDate = (dateString) => !dateString || dateString === NULLISH_DATE;
var isTicketElementSent = (ticketElement) => !!ticketElement.timeSentToKitchen && !isNullishDate(ticketElement.timeSentToKitchen);
var notTicketElementSent = (ticketElement) => !ticketElement.timeSentToKitchen || isNullishDate(ticketElement.timeSentToKitchen);
var isTicketElementTriggered = (ticketElement) => !!ticketElement.timeTriggered && !isNullishDate(ticketElement.timeTriggered);
var notTicketElementTriggered = (ticketElement) => !ticketElement.timeTriggered || isNullishDate(ticketElement.timeTriggered);
var getEntityId = (entity) => entity.id || entity.tabletGeneratedId;
var getTicketElementId = getEntityId;
var getEntityIdOrTabletGeneratedId = (entity) => entity.id || entity.tabletGeneratedId;
var isUpcEqual = (menuTypeVersion, search) => Boolean(menuTypeVersion.universalProductCode) && menuTypeVersion.universalProductCode.trim().toLowerCase() === search.trim().toLowerCase();
var isItemFoundByUpc = (items, menuTypeId, search, searchAllMenuTypes = false) => {
  if (searchAllMenuTypes) {
    return items.some((item) => {
      return Object.values(item.menuTypeVersions).some((menuTypeVersion) => {
        return isUpcEqual(menuTypeVersion, search);
      });
    });
  }
  return items.length === 1 && Boolean(menuTypeId) && isUpcEqual(items[0].menuTypeVersions[menuTypeId || 0], search);
};
var getMenuTypeIdsByUpc = (item, search, menuTypes) => {
  const menuTypeIds = [];
  Object.values(item.menuTypeVersions).forEach((menuTypeVersion) => {
    var _a;
    if (((_a = menuTypes[menuTypeVersion.menuTypeId]) == null ? void 0 : _a.active) && menuTypeVersion.active && isUpcEqual(menuTypeVersion, search)) {
      menuTypeIds.push(menuTypeVersion.menuTypeId);
    }
  });
  return menuTypeIds;
};
var getMenuTypeIdsItemsByUpc = (items, search, menuTypes) => {
  const itemMenuTypeIds = {};
  items.forEach((item) => {
    const menuTypeIds = getMenuTypeIdsByUpc(item, search, menuTypes);
    if (menuTypeIds.length > 0) {
      itemMenuTypeIds[item.itemId] = menuTypeIds;
    }
  });
  return itemMenuTypeIds;
};

export { getEntityId, getEntityIdOrTabletGeneratedId, getMenuTypeIdsByUpc, getMenuTypeIdsItemsByUpc, getTicketElementId, isItemFoundByUpc, isNullishDate, isTicketElementSent, isTicketElementTriggered, notTicketElementSent, notTicketElementTriggered };
